<template>
  <ul class="list-group">
    <li class="list-group-item list-group-item-danger"
        v-for="(error, index) in errors"
        :key="index"
        variant="danger">
      &#9679; {{ error }}
    </li>
  </ul>
</template>

<script>

export default {
  name: 'ErrorsContainer',
  props: {
    errors: Array
  }
}
</script>
